export default __webpack_public_path__ + "6700c8a.png";